export default {
  woundExudate: {
    selectedExudateAmountParameterCode: '',
    selectedExudateTypeParameterCode: '',
    showExudateType: false,
    selectedExudateAmountParaName: null,
    selectedExudateTypeParaName: null,
  },
};
